import { AdvancedFilterInputSchema } from "@redotech/redo-model/fulfillments/fulfillment-group-summary-input";
import * as z from "zod";

export const getShippingClaimsCount = {
  name: "getShippingClaimsCount" as const,
  input: AdvancedFilterInputSchema,
  output: z.object({ total: z.number() }),
};
